<template>
  <div>
    <md-card>
      <md-card-content>
        <span class="md-nav-tabs-title">OS: </span>

        <md-tabs
          ref="tabs"
          class="md-success"
          md-alignment="left"
        >
          <md-tab md-label="Abertas">
            <md-subheader>Chamados planejados ou em andamento</md-subheader>

            <loading :loading="openedTickets.loading">
              <md-table
                v-model="openedTickets.data"
                table-header-color="gray"
                @md-selected="onSelectOpen"
              >
                <md-table-empty-state md-label="Nenhum dado encontrado..." />

                <md-table-row
                  slot="md-table-row"
                  slot-scope="{ item }"
                  md-selectable="single"
                >
                  <md-table-cell md-label="Título">
                    {{ item.title }}
                  </md-table-cell>
                  <md-table-cell md-label="Data">
                    {{ item.date }}
                  </md-table-cell>
                  <md-table-cell md-label="Status">
                    {{ item.status }}
                  </md-table-cell>
                  <md-table-cell md-label="Modalidade">
                    {{ item.modality }}
                  </md-table-cell>
                  <md-table-cell md-label="ID">
                    {{ item.id }}
                  </md-table-cell>
                </md-table-row>

                <pagination
                  :current-page="openedTickets.page"
                  :page-size="openedTickets.pageSize"
                  :total-items="openedTickets.total"
                  @updatePage="loadOpenedTickets"
                />
              </md-table>
            </loading>
          </md-tab>

          <md-tab md-label="Em revisão">
            <md-subheader>Chamados em revisão pela equipe interna de supervisão</md-subheader>

            <loading :loading="waitingTickets.loading">
              <md-table
                v-model="waitingTickets.data"
                table-header-color="gray"
                @md-selected="onSelectOpen"
              >
                <md-table-empty-state md-label="Nenhum dado encontrado..." />

                <md-table-row
                  slot="md-table-row"
                  slot-scope="{ item }"
                  md-selectable="single"
                >
                  <md-table-cell md-label="Título">
                    {{ item.title }}
                  </md-table-cell>
                  <md-table-cell md-label="Data">
                    {{ item.date }}
                  </md-table-cell>
                  <md-table-cell md-label="Status">
                    {{ item.status }}
                  </md-table-cell>
                  <md-table-cell md-label="Modalidade">
                    {{ item.modality }}
                  </md-table-cell>
                  <md-table-cell md-label="ID">
                    {{ item.id }}
                  </md-table-cell>
                </md-table-row>

                <pagination
                  :current-page="waitingTickets.page"
                  :page-size="waitingTickets.pageSize"
                  :total-items="waitingTickets.total"
                  @updatePage="loadWaitingTickets"
                />
              </md-table>
            </loading>
          </md-tab>

          <md-tab md-label="Em Aprovação">
            <md-subheader>
              Chamados que estão solucionados e estão aguardando aprovação do responsável / requerente
            </md-subheader>

            <loading :loading="approvedTickets.loading">
              <md-table
                v-model="approvedTickets.data"
                table-header-color="gray"
                @md-selected="onSelectOpen"
              >
                <md-table-empty-state md-label="Nenhum dado encontrado..." />

                <md-table-row
                  slot="md-table-row"
                  slot-scope="{ item }"
                  md-selectable="single"
                >
                  <md-table-cell md-label="Título">
                    {{ item.title }}
                  </md-table-cell>
                  <md-table-cell md-label="Data">
                    {{ item.date }}
                  </md-table-cell>
                  <md-table-cell md-label="Status">
                    {{ item.status }}
                  </md-table-cell>
                  <md-table-cell md-label="Modalidade">
                    {{ item.modality }}
                  </md-table-cell>
                  <md-table-cell md-label="ID">
                    {{ item.id }}
                  </md-table-cell>
                </md-table-row>

                <pagination
                  :current-page="approvedTickets.page"
                  :page-size="approvedTickets.pageSize"
                  :total-items="approvedTickets.total"
                  @updatePage="loadApprovedTickets"
                />
              </md-table>
            </loading>
          </md-tab>

          <md-tab md-label="Fechadas">
            <md-subheader>Chamados que tiveram o ciclo de atendimento finalizado</md-subheader>

            <loading :loading="closedTickets.loading">
              <md-table
                v-model="closedTickets.data"
                table-header-color="gray"
                @md-selected="onSelectOpen"
              >
                <md-table-empty-state md-label="Nenhum dado encontrado..." />

                <md-table-row
                  slot="md-table-row"
                  slot-scope="{ item }"
                  md-selectable="single"
                >
                  <md-table-cell md-label="Título">
                    {{ item.title }}
                  </md-table-cell>
                  <md-table-cell md-label="Data">
                    {{ item.date }}
                  </md-table-cell>
                  <md-table-cell md-label="Status">
                    {{ item.status }}
                  </md-table-cell>
                  <md-table-cell md-label="Modalidade">
                    {{ item.modality }}
                  </md-table-cell>
                  <md-table-cell md-label="ID">
                    {{ item.id }}
                  </md-table-cell>
                </md-table-row>

                <pagination
                  :current-page="closedTickets.page"
                  :page-size="closedTickets.pageSize"
                  :total-items="closedTickets.total"
                  @updatePage="loadClosedTickets"
                />
              </md-table>
            </loading>
          </md-tab>
        </md-tabs>
      </md-card-content>
    </md-card>
    <new-ticket-button />
  </div>
</template>

<script>
import { DateTime } from "luxon";

import Pagination from "../components/Pagination";
import Loading from "../components/Loading";
import NewTicketButton from "../components/NewTicketButton";

import { userService } from "../_services";
import { getUserSession } from "../_services/localstorage";

import { EventBus, events } from "../_helpers/event-bus";

import { unescapeHtml } from "../util/unescape-html";

export default {
  components: {
    NewTicketButton,
    Pagination,
    Loading,
  },
  data() {
    return {
      openedTickets: {
        pageSize: 10,
        total: 0,
        page: 1,
        data: [],
        loading: false,
      },
      waitingTickets: {
        pageSize: 10,
        total: 0,
        page: 1,
        data: [],
        loading: false,
      },
      approvedTickets: {
        pageSize: 10,
        total: 0,
        page: 1,
        data: [],
        loading: false,
      },
      closedTickets: {
        pageSize: 10,
        total: 0,
        page: 1,
        data: [],
        loading: false,
      },
    };
  },
  async created() {
    this.user = getUserSession();

    await this.loadTickets();

    EventBus.$on(events.CHANGED_ENTITY, this.onEntityChange);
  },
  beforeDestroy() {
    EventBus.$off(events.CHANGED_ENTITY, this.onEntityChange);
  },
  methods: {
    async onEntityChange() {
      this.user = getUserSession();

      this.resetTables();
      await this.loadTickets();
    },

    async loadTickets() {
      await Promise.allSettled([
        this.loadOpenedTickets(this.openedTickets.page, this.openedTickets.pageSize),
        this.loadWaitingTickets(this.waitingTickets.page, this.waitingTickets.pageSize),
        this.loadApprovedTickets(this.approvedTickets.page, this.approvedTickets.pageSize),
        this.loadClosedTickets(this.closedTickets.page, this.closedTickets.pageSize),
      ]);
    },

    onSelectOpen(item) {
      if (!item.id) {
        return;
      }

      this.$router.push(`/openticket/${item.id}`);
    },

    async refreshTabsHeight() {
      await this.$nextTick();
      this.$refs.tabs.calculateTabPos();
    },

    resetTables() {
      this.openedTickets = {
        pageSize: 10,
        total: 0,
        page: 1,
        data: [],
        loading: false,
      };

      this.waitingTickets = {
        pageSize: 10,
        total: 0,
        page: 1,
        data: [],
        loading: false,
      };

      this.approvedTickets = {
        pageSize: 10,
        total: 0,
        page: 1,
        data: [],
        loading: false,
      };

      this.closedTickets = {
        pageSize: 10,
        total: 0,
        page: 1,
        data: [],
        loading: false,
      };
    },

    async loadOpenedTickets(page, pageSize, done) {
      this.openedTickets.loading = true;

      const {
        glpiLastTickets: data,
        totalTickets: total
      } = await userService.searchTicketsByStatus(this.user.token, "notold", page);

      this.openedTickets = {
        pageSize,
        total,
        page,
        loading: false,
        data: data.map(ticket => this.formatTicket(ticket))
      };

      await this.refreshTabsHeight();

      done && done();
    },

    async loadWaitingTickets(page, pageSize, done) {
      this.waitingTickets.loading = true;

      const {
        glpiLastTickets: data,
        totalTickets: total
      } = await userService.searchTicketsWaiting(this.user.token, "5", page);

      this.waitingTickets = {
        pageSize,
        total,
        page,
        loading: false,
        data: data.map(ticket => this.formatTicket(ticket))
      };

      await this.refreshTabsHeight();

      done && done();
    },

    async loadApprovedTickets(page, pageSize, done) {
      this.approvedTickets.loading = true;

      const {
        glpiLastTickets: data,
        totalTickets: total
      } = await userService.searchTicketsAproved(this.user.token, "5", page);

      this.approvedTickets = {
        pageSize,
        total,
        page,
        loading: false,
        data: data.map(ticket => this.formatTicket(ticket))
      };

      await this.refreshTabsHeight();

      done && done();
    },

    async loadClosedTickets(page, pageSize, done) {
      this.closedTickets.loading = true;

      const {
        glpiLastTickets: data,
        totalTickets: total
      } = await userService.searchTicketsByStatus(this.user.token, "6", page);

      this.closedTickets = {
        pageSize,
        total,
        page,
        loading: false,
        data: data.map(ticket => this.formatTicket(ticket))
      };

      await this.refreshTabsHeight();

      done && done();
    },

    formatTicket(ticket) {
      return {
        title: unescapeHtml(ticket.title),
        date: DateTime.fromFormat(ticket.date, "yyyy-MM-dd HH:mm:ss").toLocaleString(),
        status: this.user.convertStatus[ticket.status],
        modality: this.user.convertModality[ticket.modality],
        id: ticket.id,
      };
    },
  },
};
</script>

<style>
.md-tabs-content table thead {
  display: table-header-group;
}
</style>
